import { ChevronRight, Lock } from "lucide-react";
import { cn } from "@/lib/utils";

// Hub rail row: quiet when idle, lit in the section colour on hover, lit stronger when active.
export default function NavItem({ hub, isActive, isHovered, onClick, onMouseEnter, onMouseLeave, isAdmin = false, count = 0, locked = false }) {
  const rgb = hub.glowRgb || "var(--glow-home)";
  const lit = isActive || isHovered;
  const adminGated = hub.adminOnly && !isAdmin;

  return (
    <button
      type="button"
      onClick={adminGated ? undefined : onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      data-testid={`hubnav-${hub.id}`}
      data-active={isActive ? "1" : "0"}
      disabled={adminGated}
      title={hub.description || undefined}
      className={cn(
        "group/row w-full flex items-center gap-2.5 px-2.5 min-h-[36px] py-1.5 rounded-lg text-left transition-[background-color,box-shadow,color,transform] duration-200",
        adminGated && "opacity-50 cursor-not-allowed",
        !lit && "text-q-muted hover:text-q-text"
      )}
      style={
        lit
          ? {
              background: `rgba(${rgb},${isActive ? 0.16 : 0.1})`,
              boxShadow: `inset 0 0 0 1px rgba(${rgb},${isActive ? 0.38 : 0.26}), 0 0 ${isActive ? 22 : 18}px rgba(${rgb},${isActive ? 0.3 : 0.24})`,
              color: `rgb(${rgb})`,
              transform: isHovered && !isActive ? "translateX(2px)" : undefined,
            }
          : undefined
      }
    >
      <hub.Icon
        className="w-4 h-4 flex-shrink-0 transition-[filter,color] duration-200"
        style={{ color: lit ? `rgb(${rgb})` : `rgba(${rgb},0.75)`, filter: lit ? `drop-shadow(0 0 7px rgba(${rgb},0.85))` : "none" }}
        strokeWidth={lit ? 2.4 : 1.9}
      />
      <span className="text-[12.5px] font-semibold leading-[1.15] flex-1 min-w-0 break-words">{hub.label}</span>
      {count > 0 && (
        <span
          data-testid={`hubnav-count-${hub.id}`}
          className="text-[9px] font-black rounded-full px-1.5 py-0.5 leading-none flex-shrink-0"
          style={{ background: `rgba(${rgb},0.16)`, color: `rgb(${rgb})`, boxShadow: `0 0 8px rgba(${rgb},0.35)` }}
          title={`${count} overdue`}
        >
          {count > 99 ? "99+" : count}
        </span>
      )}
      {locked && (
        <span data-testid={`hubnav-lock-${hub.id}`} title="Restricted"
          className="text-q-faint border border-q-line rounded p-0.5 leading-none bg-q-raised flex-shrink-0">
          <Lock className="w-2.5 h-2.5" />
        </span>
      )}
      {hub.comingSoon ? (
        <span data-testid={`hubnav-soon-${hub.id}`}
          className="text-[7px] font-black tracking-[0.14em] uppercase text-orange-500/50 border border-orange-500/20 rounded px-1 py-0.5 leading-none flex-shrink-0">
          Soon
        </span>
      ) : hub.adminOnly ? (
        <span className="text-[7px] font-black tracking-[0.14em] uppercase text-violet-400/80 border border-violet-400/30 rounded px-1 py-0.5 leading-none flex-shrink-0">
          Admin
        </span>
      ) : (
        <ChevronRight
          className={cn("w-3 h-3 flex-shrink-0 transition-[opacity,transform] duration-200", lit ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-1")}
          style={{ color: `rgb(${rgb})` }}
        />
      )}
    </button>
  );
}
